<script>
export default {
  translate25Context: "vrun_form",
  components: {},
  props: ["component", "handler"],
  data() {
    return {
      focused: false,
      opened: false,
      current: null,
      width: 0,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      listHeight: 200,
    };
  },
  methods: {
    open: function ($event) {
      if (!this.current) {
        this.current = Object.keys(this.component.others)[0];
      }
      if (this.opened) {
        this.opened = false;
        return;
      }
      setTimeout(() => {
        this.opened = true;
        this.positionOptions();

        setTimeout(() => {
          $(this.$el)
            .find(".f-vrun-form-lang-textfield-others textarea")
            .first()
            .focus();
        });
      });
    },
    positionOptions: function () {
      var space = 8;

      let $el = $(this.$el).find(".f-vrun-form-lang-textfield-default");

      let offset = $el.offset();

      this.top = "auto";
      this.left = offset.left + "px";
      this.bottom = "auto";
      this.right = "auto";
      this.width = $el.width() + "px";

      if (offset.top < $(window).height() - this.listHeight) {
        this.top = offset.top + $el.outerHeight() + space;
        this.top = this.top + "px";
      } else {
        this.bottom = $(window).height() - offset.top + space;
        this.bottom = this.bottom + "px";
      }
    },
    close: function () {
      this.opened = false;
    },
  },
  computed: {
    cssVars() {
      return {
        "--height": this._props.listHeight + "px",
        "--width": this.width,
        "--left": this.left,
        "--top": this.top,
        "--right": this.right,
        "--bottom": this.bottom,
      };
    },
  },
  mounted: function () {
    window.addEventListener("resize", this.positionOptions);
  },
  destroyed() {
    window.addEventListener("resize", this.positionOptions);
  },
};
</script>

<template>
  <div class="f-vrun-form-lang-textfield">
    <f-field :optional="optional" :focused="focused">
      <template v-slot:label>{{ $vt(component.title) }}</template>
      <template v-slot:content>
        <div class="f-vrun-form-lang-textfield-default">
          <div
            class="f-language-default f-languages-container"
            :class="{ focus: focused, error: component.error }"
          >
            <div class="f-language">
              {{ $vt(component.default.label) }}
              <textarea
                class="f-form-allow-enter"
                :value="component.default.value"
                @blur="
                  focused = false;
                  component.default.value = $event.target.value;
                  handler.action(component.default, 'set', [
                    $event.target.value,
                  ]);
                "
                @focus="focused = true"
              />
              <f-button
                class="more tertiary"
                type="icon"
                v-if="Object.values(component.others).length > 0"
                @click.stop="open($event)"
              >
                <div>
                  <f-icon icon="fa6-a"> </f-icon>
                  <f-icon icon="fa6-b"> </f-icon>
                  <f-icon icon="fa6-c"> </f-icon>
                </div>
              </f-button>
            </div>
          </div>
        </div>
        <div
          class="f-vrun-form-lang-textfield-others-container"
          v-if="opened"
          @wheel="close($event)"
        >
          <div
            class="f-vrun-form-lang-textfield-others"
            :style="cssVars"
            v-click-outside="close"
            @wheel.stop
          >
            <div class="f-language-user f-languages-container">
              <div
                class="f-languages-language"
                :class="{ selected: current == nid }"
                v-for="(language, nid) in component.others"
                :key="language['#id']"
                @click="current = nid"
              >
                {{ $vt(language.label) }}
              </div>
            </div>
            <div class="f-languages-current" v-if="current">
              <textarea
                class="f-form-allow-enter"
                :value="component.others[current].value"
                @blur="
                  component.others[current].value = $event.target.value;
                  handler.action(component.others[current], 'set', [
                    $event.target.value,
                  ]);
                "
              />
            </div>
          </div>
        </div>
      </template>
      <template #helper>{{ $vt("Break lines to enter multiple values") }}</template>
    </f-field>
    <f-hint type="negative" v-if="component.error">
      <template #message>{{ $vt(component.error) }}</template>
    </f-hint>
  </div>
</template>

<style lang="scss">
.f-vrun-form-lang-textfield {
  .f-hint {
    margin-top: 6px;
  }
  .f-vrun-form-lang-textfield-others-container {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    .f-vrun-form-lang-textfield-others {
      display: flex;
      flex-direction: column;
      z-index: 1;
      background-color: white;
      box-shadow: 0px 8px 32px -8px rgba(22, 22, 21, 0.25);
      border-radius: 8px;
      padding: 8px;
      position: fixed;
      box-sizing: border-box;
      max-height: var(--height);
      left: var(--left);
      top: var(--top);
      right: var(--right);
      bottom: var(--bottom);
      width: var(--width);

      .f-languages-container {
        .f-languages-language {
          cursor: pointer;
          flex: 1 1 auto;
          color: black;
          opacity: 0.75;
          padding: 8px 0;
          border-bottom: 2px solid transparent;
          text-align: center;
          font-family: "Lato";
          font-style: normal;
          font-weight: 700;

          &.selected {
            opacity: 1;
            border-bottom: 2px solid #209fdf;
          }
        }
      }
      .f-languages-current {
        height: 100px;
        padding: 4px 8px;
      }
    }
  }

  textarea {
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #161615;
    padding: 0;
    background: transparent;
    border: none;
    width: 100%;
    outline: 0;
    overflow-y: scroll;
    resize: none;
    height: 100%;
    line-height: 16px;

    /* width */
    &::-webkit-scrollbar {
      width: 16px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-track:hover {
      border-radius: 2px;
      background: #f3f3f3;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: rgba(22, 22, 21, 0.1);
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #dddddd;
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    &:active {
      outline: none;
      border: none;
      outline: 0;
    }

    &[readonly] {
      cursor: default;
    }
  }

  .f-languages-container {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    position: relative;

    &.f-language-default {
      .more {
        cursor: pointer;
        padding: 0 8px;
        width: auto;
        font-size: 12px;

        > div {
          display: flex;
          gap: 0;
        }
      }
    }

    .f-language {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: "Lato";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: rgba(24, 24, 26, 0.5);
      width: 100%;
      height: 100px;
      padding: 8px;
      background: #f7f7f6;
      border-radius: 4px;
      border: 1px solid #bbbbb8;
      white-space: nowrap;
    }

    &:hover {
      .f-language {
        border: 1px solid rgba(24, 144, 211, 0.75);
      }
    }

    &.focus {
      .f-language {
        border: 1px solid #1890d3;
        outline: 5px solid rgba(24, 144, 211, 0.25);
      }
    }

    &.error {
      border-color: var(--statusNegative);
    }

    &.disabled {
      background: rgba(22, 22, 21, 0.05);
      border: 1px solid #bbbbb8;
      color: rgba(22, 22, 21, 0.25);

      &::placeholder {
        color: rgba(22, 22, 21, 0.25);
      }
    }
  }
}
.dark-mode {
  .f-vrun-form-lang-textfield {
    .f-vrun-form-lang-textfield-others-container {
      .f-vrun-form-lang-textfield-others {
        background-color: #000000;
        box-shadow: 0 12px 24px var(--white-a5);

        .f-languages-container {
          .f-languages-language {
            color: var(--white-a50);

            &.selected {
              border-bottom: 2px solid var(--white-a50);
            }
          }
        }
      }
    }

    textarea {
      color: var(--white-a50);

      &::-webkit-scrollbar-track:hover {
        background: #f3f3f3;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: rgba(22, 22, 21, 0.1);
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #dddddd;
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: #dddddd;
      }
    }

    .f-languages-container {
      .f-language {
        color: var(--white-a50);
        background: none;
        border: 1px solid var(--white-a25);
      }

      &:hover {
        .f-language {
          border: 1px solid rgba(24, 144, 211, 0.75);
        }
      }

      &.focus {
        .f-language {
          border: 1px solid #1890d3;
          outline: 5px solid rgba(24, 144, 211, 0.25);
        }
      }

      &.error {
        border-color: var(--statusNegative);
      }

      &.disabled {
        background: rgba(22, 22, 21, 0.05);
        border: 1px solid #bbbbb8;
        color: rgba(22, 22, 21, 0.25);

        &::placeholder {
          color: rgba(22, 22, 21, 0.25);
        }
      }
    }
  }
}
</style>